import { render } from "./ExternalApprovalVideo.vue?vue&type=template&id=5ffc8905"
import script from "./ExternalApprovalVideo.vue?vue&type=script&lang=js"
export * from "./ExternalApprovalVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__